// @flow
import React, { Component } from "react";
import { noop } from "lodash";

import type { NullaryFn, BinaryFn } from "@tvg/types/Functional";
import type {
  HandicapOptionsType,
  HandicapSortOptionsType
} from "@tvg/types/Race";
import handicappingSortOptions, {
  handicappingSortGreyhoundOptions
} from "@tvg/utils/handicapping-conf/handicappingSortOptions";

import Icon from "../../_static/Icons";
import { success, star } from "../../_static/Icons/icons";
import MessageBox from "../../_molecule/MessageBox";
import InlineInfo from "../../_atom/InlineInfo";

import buildColor from "../../_static/ColorPalette";
import {
  SortItemWrapper,
  ButtonWrapper,
  LoginMessageWrapper,
  Circle,
  FavoriteWrapper,
  DefaultInfo
} from "./styled-components";

type Props = {
  /**
   * active handicapping type
   */
  handicappingMode: HandicapOptionsType,
  /**
   * favorite handicapping type
   */
  favoriteItem: HandicapSortOptionsType,
  /**
   * active handicapping type
   */
  activeItem: HandicapSortOptionsType,
  /**
   * callback for clicking login button
   */
  loginCallBack: NullaryFn<mixed>,
  /**
   * callback for signup login button
   */
  signupCallBack: NullaryFn<mixed>,
  /**
   * callback for selecting the favorite type
   */
  onFavoriteHandicapSortSelect: BinaryFn<
    HandicapSortOptionsType,
    string,
    mixed
  >,
  /**
   * callback for selecting the handicapping type
   */
  onHandicapSortSelect: BinaryFn<HandicapSortOptionsType, string, mixed>,
  /**
   * is user logged in
   */
  isLogged: boolean,
  /**
   * if the race is for greyhounds
   */
  isGreyhound: boolean,
  /**
   * show favorite button
   */
  showFavorite: boolean
};

export default class HandicappingSortList extends Component<Props> {
  static defaultProps = {
    favoriteItem: "saddlecloth",
    activeItem: "saddlecloth",
    handicappingMode: "basic",
    onCLose: noop,
    onFavoriteHandicapSortSelect: noop,
    onHandicapSortSelect: noop,
    loginCallBack: noop,
    signupCallBack: noop,
    isLogged: false,
    isGreyhound: false,
    showFavorite: true
  };

  gethandicappingModeText = (handicappingMode: HandicapOptionsType): string => {
    let text = "";

    switch (handicappingMode) {
      case "basic":
        text = " basic summary";
        break;
      case "advanced":
        text = " advanced summary";
        break;
      case "snapshot":
        text = " snapshot";
        break;
      case "speed":
        text = " speed & class";
        break;
      case "pace":
        text = " pace";
        break;
      case "stats":
        text = " jockey/trainer stats";
        break;
      default:
        text = " basic summary";
    }

    return text;
  };

  renderOptions = () => {
    const options = this.props.isGreyhound
      ? handicappingSortGreyhoundOptions
      : handicappingSortOptions;
    return options[this.props.handicappingMode].map((option) => (
      <SortItemWrapper
        onTouchStart={noop}
        data-qa-label={option.qaLabel}
        key={`${option.key} - ${
          this.props.isGreyhound ? "greyhound" : "horse"
        }`}
        isActive={this.props.activeItem === option.key}
        showFavorite={this.props.showFavorite && this.props.isLogged}
      >
        {this.props.showFavorite && this.props.isLogged && (
          <FavoriteWrapper
            onClick={() =>
              this.props.onFavoriteHandicapSortSelect(option.key, option.title)
            }
            data-qa-label={`${option.qaLabel}Favorite`}
          >
            <Icon
              size={16}
              icon={star}
              color={
                this.props.favoriteItem === option.key
                  ? buildColor("yellow", "500")
                  : buildColor("grey", "100")
              }
              qaLabel={
                this.props.favoriteItem === option.key
                  ? "favorite"
                  : "nonFavorite"
              }
            />
          </FavoriteWrapper>
        )}
        <ButtonWrapper
          onClick={() =>
            this.props.onHandicapSortSelect(option.key, option.title)
          }
          qaLabel={`${option.qaLabel}Btn`}
        >
          <InlineInfo
            title={option.title}
            info={[option.sortData]}
            isDescriptionBold={false}
            showInfoInline
            isFirstFontMedium={false}
          />
          {this.props.activeItem === option.key ? (
            <Icon
              size={16}
              icon={success}
              color={buildColor("blue_accent", "500")}
              qaLabel="active"
            />
          ) : (
            <Circle
              size={16}
              borderColor={buildColor("grey", "100")}
              data-qa-label="nonActive"
            />
          )}
        </ButtonWrapper>
      </SortItemWrapper>
    ));
  };

  render() {
    return (
      <section>
        {!this.props.isLogged && (
          <LoginMessageWrapper>
            <MessageBox
              message="Please login to use the sorting feature"
              type="info"
              onLoginCallback={this.props.loginCallBack}
              onSignupCallback={this.props.signupCallBack}
            />
          </LoginMessageWrapper>
        )}
        {this.props.isLogged && (
          <DefaultInfo data-qa-label="handicapSortInfoLabel">
            Set as default for
            {this.gethandicappingModeText(this.props.handicappingMode)}
          </DefaultInfo>
        )}
        <ul>{this.renderOptions()}</ul>
      </section>
    );
  }
}
